import { toastMessage } from "@/(front-desk)/utils/functions";
import { createAsyncThunk } from "@reduxjs/toolkit";
import * as apis from "./apis";
import { selectReviewDraft, selectReviewStatus } from "./selectors";
import { actions } from "./store";

export const fetchMissions = createAsyncThunk(
  "user/judge/fetchMissions",
  async (_, api) => apis.fetchMissions({ signal: api.signal })
);

export const fetchProjects = createAsyncThunk(
  "user/judge/fetchProjects",
  /**
   * @param {string} subcategory
   */
  async (subcategory, api) =>
    apis.fetchProjects({ subcategory, signal: api.signal })
);

export const fetchProjectsWithFilter = createAsyncThunk(
  "user/judge/fetchProjectsWithFilter",
  /**
   * @param {object} params
   * @param {string} params.subcategory
   * @param {number} params.stage
   * @param {number?} params.page
   * @param {number?} params.page_size
   * @param {JudgeProjectQueryParams} params.filter
   */
  async ({ subcategory, stage, page, page_size, filter }, api) =>
    apis.fetchProjects({
      subcategory,
      stage,
      page,
      page_size,
      filter,
      signal: api.signal,
    })
);

export const fetchJudgeStages = createAsyncThunk(
  "user/judge/fetchJudgeStages",
  async (_, api) => {
    const stages = await apis.fetchStages({
      type: "competition",
      signal: api.signal,
    });

    return stages;
  }
);

export const submitReview = createAsyncThunk(
  "user/judge/submitReview",
  /**
   *
   * @param {(nextProjectId: number)=>void} callback
   * @param api
   */
  async (callback, api) => {
    const { id } = selectReviewStatus(api.getState());
    const { score, review, memo, phase } = selectReviewDraft(api.getState());
    try {
      const resp = await apis.submitReview({
        id,
        draft: { score, review, memo, stage: parseInt(phase, 10) },
      });
      api.dispatch(actions.setReviewDirty(false));
      api.dispatch(actions.setReviewSubmitted(true));
      toastMessage("success", "評分資料已儲存！");
      if (callback) callback(resp.next_project_id);
    } catch {
      toastMessage("error", "系統出了點問題，請稍候再試一次！");
    }
  }
);
